import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import {
    IApiListParams,
    ICustomTeamApiListResponse,
    ICustomTeamUpdateParams,
    ICustomTeamUpdateResponse,
    ICustomTeamUploadLogoResponse,
    ITeamSearchResponse,
} from '@/types';

export const searchCustomTeams = (
    query: string | string[],
    sportId: number,
    isWomen?: 0 | 1,
    isYouth?: 0 | 1,
    countryId?: number | null
): Promise<AxiosResponse<ITeamSearchResponse>> => {
    return axios.get('/api/customTeam/search', {
        params: { query, sport_id: sportId, is_women: isWomen, is_youth: isYouth, country_id: countryId },
    });
};

export const customTeamList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ICustomTeamApiListResponse>> => {
    return axios.get('/api/customTeam/list', { ...config, params });
};

export const customTeamCreate = (params: ICustomTeamUpdateParams): Promise<AxiosResponse<ICustomTeamUpdateResponse>> => {
    return axios.post('/api/customTeam/create', params);
};

export const customTeamDelete = (params: ICustomTeamUpdateParams): Promise<AxiosResponse<ICustomTeamUpdateResponse>> => {
    return axios.post('/api/customTeam/delete', params);
};

export const customTeamUpdate = (params: ICustomTeamUpdateParams): Promise<AxiosResponse<ICustomTeamUpdateResponse>> => {
    return axios.post('/api/customTeam/update', params);
};

export const customTeamUploadLogo = (id: number, file: File): Promise<AxiosResponse<ICustomTeamUploadLogoResponse>> => {
    const formData = new FormData();
    formData.append('id', String(id));
    formData.append('file', file);
    return axios.post('/api/customTeam/uploadLogo', formData);
};
